module.exports = __webpack_public_path__ + "img/noimage.92793810.png";